import type { AppDispatch } from '@/app/store/store';
import { createNewHomeService } from '../application/services/NewHomeService';
import { newHomeAdapter } from '../infra/adapters/newHome.adapter';
import { plpAdapter } from '@/features/plp/infra/adapters/plp.adapter';
import { FiltersAdapter } from '@/features/filters/infra/adapters/filters.adapter';
import { SeoAdapter } from '@/shared/features/seo/infra/adapters/seo.adapter';

/**
 * Factory function to wire infrastructure → application layer.
 * Follows the same cross-feature DI pattern as PLP's plp.build.ts
 * which injects PhysicalStoreAdapter into PlpService.
 * Here we inject PLP's adapter so newHome can fetch recommended products,
 * and FiltersAdapter so newHome can fetch filter previews independently.
 */
export function newHomeBuild(dispatch: AppDispatch) {
  const homeRepo = new newHomeAdapter();
  const seoRepo = new SeoAdapter(dispatch);
  const plpRepo = new plpAdapter(dispatch, seoRepo);
  const filtersRepo = new FiltersAdapter(dispatch);
  const service = createNewHomeService(homeRepo, plpRepo, filtersRepo);
  return { service };
}
